export const GET_PERSON_SALES_REPORT_LIST_START = "GET_PERSON_SALES_REPORT_LIST_START";
export const GET_PERSON_SALES_REPORT_LIST_SUCCESS = "GET_PERSON_SALES_REPORT_LIST_SUCCESS";
export const GET_PERSON_SALES_REPORT_LIST_FAILURE = "GET_PERSON_SALES_REPORT_LIST_FAILURE";

export const SEARCH_PERSON_SALES_NAME = "SEARCH_PERSON_SALES_NAME";